<template>
  <div
    class="fixed z-20 inset-0 overflow-y-auto"
    v-show="isOpen"
    @click="closeOnOutsideClick ? $emit('onClose') : null"
  >
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-top sm:h-screen"></span
      >&#8203;

      <div
        @click.stop
        class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    closeOnOutsideClick: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  methods: {}
};
</script>

<style scoped></style>
